import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../../../../components/Accessibility/PageTitle';
import DefaultButton from '../../../../../components/Accessibility/DefaultButton';
import VoltarButton from '../../../../../components/Accessibility/VoltarButton';
import LoadingApp from '../../../../../components/LoadingApp';
import ModalFeedBack from '../../../../../components/ModalFeedBack';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { TranscricaoAnexosUploadSemValidacao } from '../../components/TranscricaoAnexos';
import TranscricaoPendenciaMensagemCard from './TranscricaoPendenciaMensagemCard';
import { useResolverPendenciaPage } from './hooks/useResolverPendenciaPage';
import { sxResolverConcluirButton, sxResolverJustificativa, sxResolverJustificativaSection, sxResolverPage } from './sxResolverPendencia';
import '../../NovaTranscricao/styles.css';
import './styles.css';

const ResolverPendenciaTranscricao: React.FC = () => {
  const navigate = useNavigate();
  const accessibility = useAccessibility();
  const {
    loading,
    enviando,
    erro,
    detalhe,
    anexos,
    setAnexos,
    justificativa,
    setJustificativa,
    maxJustificativa,
    mensagemPendencia,
    dataMensagem,
    showModalErro,
    setShowModalErro,
    tituloModalErro,
    subTituloModalErro,
    showModalSucesso,
    podeResolver,
    detalhesPath,
    handleConcluir,
    handleEntendiSucesso,
  } = useResolverPendenciaPage();

  return (
    <Box className="transcricao-resolver-container" sx={sxResolverPage}>
      <LoadingApp showLoading={loading || enviando} />

      {!loading && (
        <>
          <PageTitle text="Resolver pendência" className="transcricao-resolver-title" />

          {detalhe?.codProtocoloans?.trim() && (
            <Typography
              component="p"
              className="transcricao-resolver-protocolo"
              style={accessibility.textStyleAccessibility}
            >
              Protocolo: {detalhe.codProtocoloans.trim()}
            </Typography>
          )}

          {erro && (
            <Typography className="transcricao-resolver-erro" style={accessibility.textStyleAccessibility}>
              {erro}
            </Typography>
          )}

          {podeResolver && (
            <>
              <TranscricaoPendenciaMensagemCard
                mensagem={mensagemPendencia}
                dataMensagem={dataMensagem}
              />

              <TranscricaoAnexosUploadSemValidacao anexos={anexos} onAnexosChange={setAnexos} />

              <Box className="transcricao-resolver-justificativa" sx={sxResolverJustificativaSection}>
                <label
                  htmlFor="justificativa-pendencia"
                  className="transcricao-resolver-justificativa-label"
                  style={accessibility.textStyleAccessibility}
                >
                  Inclua uma justificativa
                </label>
                <TextField
                  id="justificativa-pendencia"
                  multiline
                  fullWidth
                  minRows={6}
                  value={justificativa}
                  onChange={(event) => {
                    setJustificativa(event.target.value.slice(0, maxJustificativa));
                  }}
                  inputProps={{
                    maxLength: maxJustificativa,
                    'aria-describedby': 'justificativa-pendencia-contador',
                  }}
                  sx={sxResolverJustificativa}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography
                          id="justificativa-pendencia-contador"
                          component="span"
                          className="transcricao-resolver-justificativa-contador"
                          style={accessibility.textStyleAccessibility}
                        >
                          {justificativa.length}/{maxJustificativa}
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <div className="transcricao-resolver-actions">
                <DefaultButton
                  text="CONCLUIR"
                  onClick={handleConcluir}
                  disabled={enviando}
                  sx={sxResolverConcluirButton}
                />
                <VoltarButton onClick={() => navigate(detalhesPath)} />
              </div>
            </>
          )}
        </>
      )}

      <ModalFeedBack
        showModal={showModalErro}
        handleShowModal={() => setShowModalErro(false)}
        icon="error"
        textButton="Fechar"
        title={tituloModalErro}
        subTitle={subTituloModalErro}
        showButtonModal
        handleButtonModal={() => setShowModalErro(false)}
        classNameModal="modal-feedback-error"
      />

      <ModalFeedBack
        showModal={showModalSucesso}
        handleShowModal={handleEntendiSucesso}
        icon="success"
        textButton="ENTENDI"
        title="Pendência enviada!"
        subTitle="Sua solicitação foi encaminhada para nossa equipe e já está em processo de análise."
        showButtonModal
        handleButtonModal={handleEntendiSucesso}
      />
    </Box>
  );
};

export default ResolverPendenciaTranscricao;
